"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENERAL_ERRORS = exports.CAN_USE_DOM = exports.VALIDATION_ERROR = exports.ERROR = exports.VARY_HEADER = exports.CACHE_CONTROL_HEADER = exports.QS_STRINGIFY_OPTIONS = void 0;
exports.QS_STRINGIFY_OPTIONS = {
    arrayFormat: 'comma',
    skipNulls: true,
};
var DAY = 60 * 60 * 24;
var MINUTE = 60 * 1;
var CACHE_VALUE = process.env.ENV === 'production' ? 1 * DAY : 10 * MINUTE;
exports.CACHE_CONTROL_HEADER = "public, max-age=".concat(CACHE_VALUE, ", s-maxage=").concat(CACHE_VALUE);
exports.VARY_HEADER = 'origin, accept-encoding';
var ERROR;
(function (ERROR) {
    ERROR["INVALID_DATA"] = "INVALID_DATA";
    ERROR["INVALID_OPERATION"] = "INVALID_OPERATION";
    ERROR["ACCESS_DENIED"] = "ACCESS_DENIED";
    ERROR["NO_SUCH_PROFILE"] = "NO_SUCH_PROFILE";
    ERROR["UNEXPECTED_ERROR"] = "UNEXPECTED_ERROR";
    ERROR["UNAUTHORIZED_REQUEST"] = "UNAUTHORIZED_REQUEST";
    ERROR["ITEM_ALREADY_EXISTS"] = "ITEM_ALREADY_EXISTS";
    ERROR["NOT_EXIST"] = "NOT_EXIST";
    ERROR["FORM_IS_NOT_EXIST"] = "FORM_IS_NOT_EXIST";
    ERROR["FORM_IS_NOT_ACTIVE"] = "FORM_IS_NOT_ACTIVE";
    ERROR["TERMS_IS_NOT_ACCEPTED"] = "TERMS_IS_NOT_ACCEPTED";
    ERROR["ITEM_WITH_SUCH_SLUG_ALREADY_EXISTS"] = "ITEM_WITH_SUCH_SLUG_ALREADY_EXISTS";
})(ERROR || (exports.ERROR = ERROR = {}));
var VALIDATION_ERROR;
(function (VALIDATION_ERROR) {
    VALIDATION_ERROR["REQUIRED"] = "REQUIRED";
    VALIDATION_ERROR["TOO_SHORT"] = "TOO_SHORT";
    VALIDATION_ERROR["TOO_LONG"] = "TOO_LONG";
    VALIDATION_ERROR["TOO_WEAK"] = "TOO_WEAK";
    VALIDATION_ERROR["INVALID_FORMAT"] = "INVALID_FORMAT";
    VALIDATION_ERROR["INVALID_VALUE"] = "INVALID_VALUE";
    VALIDATION_ERROR["ONLY_HEBREW"] = "ONLY_HEBREW";
    VALIDATION_ERROR["MIN_DIGITS"] = "MIN_DIGITS";
    VALIDATION_ERROR["MAX_DIGITS"] = "MAX_DIGITS";
    VALIDATION_ERROR["MAX_CHARACTERS"] = "MAX_CHARACTERS";
    VALIDATION_ERROR["SLUG_REGEXP_ERROR"] = "SLUG_REGEXP_ERROR";
    VALIDATION_ERROR["FILE_IS_TOO_LARGE"] = "FILE_IS_TOO_LARGE";
    VALIDATION_ERROR["UNSUPPORTED_FILE_FORMAT"] = "UNSUPPORTED_FILE_FORMAT";
    VALIDATION_ERROR["ACCEPT_TEXT_WRONG_STRUCTURE"] = "ACCEPT_TEXT_WRONG_STRUCTURE";
    VALIDATION_ERROR["FIELD_FORM_NAME_REGEXP_ERROR"] = "FIELD_FORM_NAME_REGEXP_ERROR";
    VALIDATION_ERROR["FIELD_FORM_LINK_REGEXP_ERROR"] = "FIELD_FORM_LINK_REGEXP_ERROR";
    VALIDATION_ERROR["FILE_HAS_WRONG_WIDTH_OR_HEIGHT"] = "FILE_HAS_WRONG_WIDTH_OR_HEIGHT";
    VALIDATION_ERROR["ONCE_PER_USER_FIELD_MISMATCH"] = "ONCE_PER_USER_FIELD_MISMATCH";
    VALIDATION_ERROR["FIELDS_HAVE_ITEMS_WITH_SAME_NAME"] = "FIELDS_HAVE_ITEMS_WITH_SAME_NAME";
})(VALIDATION_ERROR || (exports.VALIDATION_ERROR = VALIDATION_ERROR = {}));
exports.CAN_USE_DOM = typeof window !== 'undefined';
exports.GENERAL_ERRORS = (_a = {},
    _a[VALIDATION_ERROR.REQUIRED] = 'שדה נדרש',
    _a[VALIDATION_ERROR.TOO_SHORT] = 'Too short',
    _a[VALIDATION_ERROR.TOO_LONG] = 'Too long',
    _a[VALIDATION_ERROR.TOO_WEAK] = 'Too weak',
    _a[VALIDATION_ERROR.INVALID_FORMAT] = 'Invalid format',
    _a[VALIDATION_ERROR.INVALID_VALUE] = 'Invalid value',
    _a[VALIDATION_ERROR.ONLY_HEBREW] = 'Only hebrew characters are supported',
    _a[VALIDATION_ERROR.MIN_DIGITS] = 'Values must be not less than 10',
    _a[VALIDATION_ERROR.MAX_DIGITS] = 'Values must be not more than 10',
    _a[VALIDATION_ERROR.MAX_CHARACTERS] = 'Values mast be not more than 15',
    _a[VALIDATION_ERROR.FIELDS_HAVE_ITEMS_WITH_SAME_NAME] = 'Fields array has items with the same name',
    _a[VALIDATION_ERROR.FIELD_FORM_NAME_REGEXP_ERROR] = 'Must be written in English and with "camelCase"',
    _a[VALIDATION_ERROR.ACCEPT_TEXT_WRONG_STRUCTURE] = 'ישנו שומר מקום מיותר לתקנון או לתנאי השימוש בתוכן ההודעה. נא להסיר את המיותר',
    _a[VALIDATION_ERROR.FILE_HAS_WRONG_WIDTH_OR_HEIGHT] = 'מידות הקובץ שהועלו אינו תקינות. נא להעלות קובץ במידות widthxheight פיקסלים',
    _a[VALIDATION_ERROR.UNSUPPORTED_FILE_FORMAT] = 'הקובץ שהועלה אינו נתמך. יש להעלות קובץ בפורמט jpg או png',
    _a[VALIDATION_ERROR.FIELD_FORM_LINK_REGEXP_ERROR] = 'הקישור חייב להכיל http:// או https://',
    _a[VALIDATION_ERROR.FILE_IS_TOO_LARGE] = 'התמונה שהועלתה גדולה מדי',
    _a[VALIDATION_ERROR.SLUG_REGEXP_ERROR] = 'השדה יכול להכיל רק אותיות קטנות באנגלית, מספרים ואת התווים הבאים: _,-. ללא רווחים',
    _a);
//# sourceMappingURL=other.js.map